import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import store from './../state/store'
import routes from './routes'
import { AUTH_ROUTES } from './auth-routes'
import localSave from './../utils/local-save'
import postAuthRedirect from './../utils/post-auth-redirect'
import { trimTrailingSlash } from './../utils/urls'

import analyticsService from './../services/analytics-service'

Vue.use(VueRouter)
Vue.use(VueMeta, {
    keyName: 'page',
    tagIDKeyName: 'vmid',
})

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) return { selector: to.hash }
        if (savedPosition) return savedPosition
        else return { x: 0, y: 0 }
    },
})

router.beforeEach((routeTo, routeFrom, next) => {
    if (routeTo.path !== '/' && routeTo.path.slice(-1) === '/') {
        next({ path: trimTrailingSlash(routeTo.path) })
    }

    if (routeTo.path.includes('/search') && routeFrom.path && !routeFrom.path.includes('/search')) {
        localSave.save('searchPreviousPath', routeFrom.fullPath || routeFrom.path, 'sessionStorage')
    }

    const authRequired = () => {
        return routeTo.matched.some(route => route.meta.authRequired)
    }

    const redirectToLogin = () => {
        next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
    }

    const saveRedirectUrl = () => {
        // removed 'home' exception due to redirecting issue from various pages
        if (AUTH_ROUTES.indexOf(routeTo.name) === -1) {
            localSave.save('redirectURL', routeTo.path)
        }
    }

    const saveHistory = () => {
        store.commit('status/SET_HISTORY_LENGTH', store.state.status.historyLength + 1)
    }

    saveHistory()

    saveRedirectUrl()

    postAuthRedirect.clearOnAuthFlowExit(routeFrom, routeTo)

    if (store.getters['auth/loggedIn']) {
        return store.dispatch('auth/userExists').then(existedUser => {
            existedUser && next()
        })
    }

    if (authRequired()) {
        return store.dispatch('auth/validate').then(validUser => {
            validUser ? next() : redirectToLogin()
        })
    }

    next()
})

router.afterEach(() => {
    analyticsService.trackPageView()
})

export default router
